import { Box, styled } from '@mui/material';

export const Content = styled(Box)(({ theme }) => ({
  backgroundColor : theme.palette.primary.white,
  borderRadius    : '10px',
  width           : '416px',
  height          : '182px',
  cursor          : 'pointer',

  display   : 'flex',
  gap       : '15px',
  padding   : '23px 20px',
  boxSizing : 'border-box',

  border    : `1px solid ${theme.palette.primary.grey3}`,
  '&:hover' : {
    border : `1px solid ${theme.palette.primary.blue1}`,
  },
}));
